import { History } from 'history';
import { createContext, ReactNode, useEffect, useMemo, useState } from 'react';
import { RouteObject } from 'react-router';

import {
  setUpLocationSync,
  waitForAngularReady,
} from './AngularProvider.utils';

interface IAngularContext {
  isReady: boolean;
}

interface AngularProviderProps {
  children: ReactNode | ReactNode[];
  routeConfig: RouteObject[];
  history: History;
}

export const AngularContext = createContext<IAngularContext>({
  isReady: false,
});

export function AngularProvider({
  children,
  routeConfig,
  history,
}: AngularProviderProps) {
  const [isReady, setIsReady] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => waitForAngularReady({ setIsReady }), []);
  useEffect(
    () =>
      setUpLocationSync({
        isReady,
        currentPath,
        setCurrentPath,
        history,
        routeConfig,
      }),
    [isReady, currentPath, history, routeConfig],
  );

  const contextValue = useMemo(
    () => ({
      isReady,
    }),
    [isReady],
  );

  return (
    <AngularContext.Provider value={contextValue}>
      {children}
    </AngularContext.Provider>
  );
}
